import addAnnouncement from './addAnnouncement';

function findChartByName(charts, name) {
  return charts.find(chart => chart.name === name);
}

export default function transformDashboard(chartList) {
  for (const chart of chartList) {
    chart.series = chart.series.map(serie => ({ ...serie, name: serie.title }));
  }

  const chartListWithAnnouncement = chartList.map(chart =>
    addAnnouncement(chart),
  );
  const charts = {
    installRemove: findChartByName(chartListWithAnnouncement, 'new_install'),
    activeInstall:
      findChartByName(chartListWithAnnouncement, 'active_install') || {},
    purchase: findChartByName(chartListWithAnnouncement, 'purchases') || {},
    rate: findChartByName(chartListWithAnnouncement, 'review') || {},
    conversionRate:
      findChartByName(chartListWithAnnouncement, 'conversion_rate') || {},
    installationHealth:
      findChartByName(chartListWithAnnouncement, 'installation_health') || {},
    accumulativeInstallFromBazaar: findChartByName(
      chartListWithAnnouncement,
      'accumulative_install_from_bazaar',
    ),
  };
  return charts;
}
